import { render, staticRenderFns } from "./AddEvent.vue?vue&type=template&id=074b596d&scoped=true"
import script from "./AddEvent.vue?vue&type=script&lang=js"
export * from "./AddEvent.vue?vue&type=script&lang=js"
import style0 from "./AddEvent.vue?vue&type=style&index=0&id=074b596d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074b596d",
  null
  
)

export default component.exports